<template>
    <div  class="aboutus">
	<!-- 	<h2>{{article.title}}</h2>
		<p>{{article.content}}</p> -->
		<b-card header-tag="header">
		<h3 solt="header" class="mb-0 aboutus-title">关于我们</h3>
			<b-card-text style="border: 1px solid #e9e9e9;">
        <p class="aboutus-body" v-html="article.content"></p>
			</b-card-text>
		</b-card>
		<div class="aboutus-footer">
		    <p>版权所有 © 广州缤纷园艺有限公司 <a href="https://beian.miit.gov.cn" target="_blank" >粤ICP备05082648号-15</a></p>
		    <p>建议使用IE10.0或以上版本浏览本网站</p>
		</div>
    </div>
</template>

<script>
	import api from '@/api/api';
	import search from '@/libs/search';
	import "@/style/global.css";
export default {
    name:"AboutUs",
    data() {
        return {
			article:{},

        };
    },
	mounted() {
		this.getNoticeList();
	},
	methods: {
		getNoticeList() {
			api.getNoticeList({noticeType:'关于我们'}).then(res => {
				if (res.code === 0) {
					if (res.data != null && res.data != '') {
						this.article = res.data[0];
					}
				}
			});
		},
	},
	components: {

	},
};
</script>

<style>
	.aboutus{margin-top: 20px;;}
	.aboutus .card {
			width: 100%;
			height: 100%;
			border: none;
			margin-left: 5px;
		}

		.aboutus .card-body {
		padding: 0;
		}

		.aboutus .aboutus-title {
			padding: 8px 20px;
			color: #FFFFFF;
			background-color: #1da25a;
		}

		.aboutus .aboutus-body {
			font-size: 25px;
			color: dimgray;
			padding: 50px;
		}
		.aboutus-footer{width:1170px;margin:20px auto;position:absolute;bottom:0}
		.aboutus-footer p{font-size:14px;color:#8b8b8b;text-align: center;}
		.aboutus-footer a{color:#8b8b8b;}

</style>



// WEBPACK FOOTER //
// src/view/about/about.vue